<template>
  <div class="standart-page">
    <b-modal
      id="modal-cancel-confirm"
      centered
      title="Uyarı"
      header-bg-variant="warning"
      header-text-variant="light"
      ok-variant="success"
      ok-title="Tamam"
      cancel-variant="outline-secondary"
      cancel-title="Vazgeç"
      @ok.prevent="$router.go(-1)"
    >
    </b-modal>
    <div class="row mb-3">
      <div class="col-3"></div>
      <div class="col d-flex align-items-center justify-content-center">
        <h3 class="title mb-0">{{ pageTitle }}</h3>
      </div>
      <div class="col-3 d-flex justify-content-end align-items-center">
        <button class="btn btn-outline-secondary back-button" @click="goBack">
          <font-awesome-icon icon="angle-double-left" class="mr-2" />
          Listeye Geri Dön
        </button>
      </div>
    </div>
    <div>
  </div>
    <div class="card-component">
      <form @submit.prevent="submit" v-disabled="!$can('create','/meslek-birligi/MBBakanlikBildirimi')">
        <div class="body" id="printobj">
          <div class="row">
            <div class="col-sm-3">
                <div class="form-group">
                    <label>Bildirim Durumu</label>
                    <select v-select class="form-control" :disabled="($store.state.auth.user.mbId === 0)" v-model="form.bildirimDurumu" :class="{ 'is-invalid': $v.form.bildirimDurumu.$error }">
                        <option :value="null">Seçiniz</option>
                        <option :value="item.id"
                                v-for="(item,index) in $store.state.general.parameters.bildirimDurumu" :key="index">
                                {{ item.name }}
                        </option>
                    </select>
                    <template v-if="$v.form.bildirimDurumu.$error">
                        <small class="text-danger" v-if="!$v.form.bildirimDurumu.required">{{ getMessage(177) }}</small>
                    </template>
                </div>
            </div>
            <div class="col-sm-6">
                <div class="form-group">
                    <label>Bildirim Başlığı</label>
                    <input type="text" :disabled="($store.state.auth.user.mbId !== 0)" class="form-control" v-model="form.bildirimBaslik" :class="{ 'is-invalid': $v.form.bildirimBaslik.$error }">
                    <template v-if="$v.form.bildirimBaslik.$error">
                        <small class="text-danger" v-if="!$v.form.bildirimBaslik.required">{{ getMessage(178) }}</small>
                    </template>
                </div>
            </div>
            <div class="col-sm-3">
                <div class="form-group">
                    <label>Bildirim Türü</label>
                    <select v-select class="form-control" v-model="form.bildirimTuru" @change="bildirimTuruChange()" :disabled="($store.state.auth.user.mbId !== 0)"
                        :class="{ 'is-invalid': $v.form.bildirimTuru .$error }">
                    <option :value="null">Seçiniz</option>
                    <option :value="item.id"
                            v-for="(item,index) in $store.state.general.parameters.bakanlikBildirimiTuruListe" :key="index">
                            {{ item.name }}
                    </option>
                    </select>
                    <template v-if="$v.form.bildirimTuru .$error">
                        <small class="text-danger" v-if="!$v.form.bildirimTuru .required">{{ getMessage(179) }}</small>
                    </template>
                </div>
            </div>
            <div class="col-12" v-for="(item,index) in mbBildirimDosya" :key="index">
              <div class="row" v-if="$store.state.auth.user.mbId === 0 || (item.link !== '' && $store.state.auth.user.mbId !== 0)">
                <div :class="item.link != '' && $store.state.auth.user.mbId === 0 ? 'col-6' : 'col-9'">
                  <div class="form-group">
                    <input type="text" class="form-control" disabled v-model="item.dosyaAdi">
                  </div>
                </div>
                <div v-if="$store.state.auth.user.mbId === 0" class="col-3">
                  <div class="row">
                    <div :class="item.recordId === 0 && item.dosyaAdi != '' ? 'col-8' : 'col-12'">
                      <input type="file" multiple :id="'file' + index" class="d-none" @change="onChangeFileUpload(index)">
                      <button type="button" class="btn btn-secondary w-100" @click="onChangeFileUploadClick(index)" :disabled="($store.state.auth.user.mbId !== 0)">Doküman Seç</button>
                    </div>
                    <div class="col-4" v-if="item.recordId === 0 && item.dosyaAdi != ''">
                      <button type="button" @click="onFileRemove(item)" class="btn btn-danger w-100"><font-awesome-icon icon="trash-alt" size="sm"></font-awesome-icon></button>
                    </div>
                  </div>
                </div>
                <div v-if="item.link != ''" class="col-3">
                  <a target="_blank" :href="item.link" class="btn btn-block mr-2 btn-outline-secondary w100">Görüntüle</a>
                </div>
              </div>
            </div>
            <div class="col-sm-12">
                <div class="form-group">
                    <label>Bakanlık Açıklama</label>
                    <ckeditor :editor="editor" :config="editorConfig" v-model="form.bakanlikAciklama" :disabled="($store.state.auth.user.mbId !== 0)"></ckeditor>
                </div>
            </div>
            <div class="col-sm-12">
                <div class="form-group">
                    <label>Meslek Birliği Açıklama</label>
                    <ckeditor :editor="editor" v-model="form.mbAciklama" :disabled="($store.state.auth.user.mbId === 0)" :config="editorConfig"></ckeditor>
                </div>
            </div>
            <div class="col-sm-3" v-if="form.recordId !== 0 && $store.state.auth.user.mbId === 0">
                <div class="form-group">
                  <label>Meslek Birliği</label>
                  <select v-select disabled
                      class="form-control"
                      v-model="form.parentId">
                    <option :value="0" v-if="mblist.length > 1">Seçiniz</option>
                    <option :value="item.id"
                        v-for="(item,index) in mblist"
                        :key="index">
                      {{ item.name }}
                    </option>
                  </select>
                </div>
            </div>
          </div>
          <div class="row" v-if="$store.state.auth.user.mbId === 0 && form.recordId === 0">
            <div class="col-sm-4">
                <div class="form-group">
                    <label>Faaliyet Sektörü</label>
                    <select v-select class="form-control" @change="listofMBIdChange(1)" v-model="form.faaliyetSektoru">
                        <option :value="0">Seçiniz</option>
                        <option :value="item.id"
                                v-for="(item,index) in $store.state.general.parameters.faaliyetSektoru" :key="index">
                                {{ item.name }}
                        </option>
                    </select>
                </div>
            </div>
            <div class="col-sm-4">
                <div class="form-group">
                    <label>Faaliyet Alanı</label>
                    <select v-select class="form-control" @change="listofMBIdChange(2)" v-model="form.faaliyetAlani">
                        <option :value="0">Seçiniz</option>
                        <option :value="item.id"
                                v-for="(item,index) in $store.state.general.parameters.faaliyetAlani" :key="index">
                                {{ item.name }}
                        </option>
                    </select>
                </div>
            </div>
            <div class="col-sm-4">
                <div class="form-group mt-4">
                  <button type="button" class="btn btn-success btn-block mt-0" @click="listofMBIdChange(3)">Tüm Meslek Birlikleri</button>
                </div>
            </div>
            <div class="col-sm-12">
              <div class="form-group">
                <label>Meslek Birliği</label>
                <multiselect v-model="listofMBId" placeholder="Seçiniz" label="name"
                  selectLabel="Seçmek için enter tuşuna basın" selectedLabel="Seçildi"
                  deselectLabel="Silmek için enter tuşuna basın" track-by="id"
                  :options="mblist" :multiple="true"
                  :taggable="true"></multiselect>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
    <div class="row justify-content-end">
      <div class="col-2 d-flex justify-content-end mt-4">
        <button class="btn btn-outline-secondary btn-block mt-0 mr-2" @click="print">Yazdır</button>
        <button class="btn btn-outline-secondary btn-block mt-0 mr-2" @click="clearForm">Temizle</button>
        <Can I="create" a="/meslek-birligi/MBBakanlikBildirimi">
          <button class="btn btn-success btn-block mt-0" @click="submit">
            Kaydet
          </button>
        </Can>
      </div>
    </div>
  </div>
</template>
<style>
  .ck-editor__editable {
    min-height: 150px;
   }
</style>
<script>

import { mapActions, mapGetters } from "vuex";
import { required } from "vuelidate/lib/validators";
import moment from 'moment';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
export default {
  components: {},
  data() {
    return {
      editor: ClassicEditor,
      editorConfig: {
        toolbar: {
          items: [
            'heading',
            '|',
            'bold',
            'italic',
            'link',
            'bulletedList',
            'numberedList',
            'imageUpload',
            'blockQuote',
            'undo',
            'redo'
          ]
        }
      },
      activeTab: 0,
      overlay: false,
      pageTitle:'Yeni Bakanlık Bildirimi Girişi',
      mblist:[],
      listofMBId:[],
      mbBildirimDosya:[],
      form: {
          recordId:0,
          parentId: parseInt(this.$store.state.mb.recordId),
          bildirimTuru :null,
          comment:"",
          bildirimBaslik:"",
          bildirimDurumu:1,
          bakanlikAciklama:"",
          mbAciklama:"",
          faaliyetSektoru:0,
          faaliyetAlani:0,
          listofMBId:"",
          bildirimiYapanUserName:"",
          bildirimTarihi:"",
          mbBildirimDosya:[]
      }
    };
  },
  validations: {
    form: {
        bildirimTuru :{
          required
        },
        bildirimBaslik:{
          required
        },
        bildirimDurumu:{
          required
        }
    }
  },
  computed: {
    ...mapGetters('general', ['getMessage', 'getOptionWithParams', 'pushListObject', 'removeListObject'])
  },
  methods: {
    ...mapActions('uye', ['getMBList']),
    ...mapActions('general', ['showModal', 'errorHandling', 'fileUpload']),
    ...mapActions('mb', ['getMeslekBirligiBakanlikBildirimi', 'saveMeslekBirligiBakanlikBildirimi', 'deleteMeslekBirligiBakanlikBildirimi']),
    submit() {
      this.$v.form.$touch();
      if (!this.$v.form.$invalid) {
        if(this.$store.state.auth.user.mbId === 0 && this.listofMBId.length === 0){
          this.showModal({title: 'Hata!', message: this.getMessage(382), type: 'danger'});
          return;
        }
        // if(this.isEmptyFile()){
        //   this.showModal({title: 'Hata!', message: this.getMessage(383), type: 'danger'});
        //   return;
        // }
        this.$store.state.general.showOverlay = true;
        this.myFileUpload();
      }
    },
    myFileUpload(index = 0){
      if(this.mbBildirimDosya.length === index){
        this.$store.state.general.showOverlay = false;
        this.saveBildirim();
        return;
      }else{
        if(!this.mbBildirimDosya[index].file){
          this.myFileUpload(index+1);
          return;
        }
      }
      const formData = new FormData();
      formData.append('file', this.mbBildirimDosya[index].file);
      this.fileUpload(formData).then((res) => {
        if(res.errorCode == 0){
          this.mbBildirimDosya[index].link = res.data.fileRepresenter;
          if(this.mbBildirimDosya.length === (index + 1)){
            this.saveBildirim();
            this.$store.state.general.showOverlay = false;
          }else{
            this.myFileUpload(index + 1);
          }
        }else{
          this.errorHandling(res);
          this.$store.state.general.showOverlay = false;
        }
      }).catch((err) => {
        this.showModal({title: 'Hata!', message: err, type: 'danger'});
        this.$store.state.general.showOverlay = false;
      });
    },
    saveBildirim(){
      if(this.listofMBId.length > 0){
        this.listofMBId.forEach(element => {
          this.form.listofMBId += element.id + ",";
        });
        this.form.listofMBId = this.form.listofMBId.substring(0, this.form.listofMBId.length - 1).toString();
      }
      this.form.mbBildirimDosya = [];
      this.mbBildirimDosya.forEach(element => {
        if(element.link !== ""){
          this.form.mbBildirimDosya.push(element);
        }
      });
      this.saveMeslekBirligiBakanlikBildirimi(this.form).then((res) => {
        if(res.errorCode == 0){
            //this.getRecord();
            this.$bvModal.hide('modal-bildirim-edit');
            if(this.form.recordId != 0){
              this.showModal({title: 'İşlem Başarılı', message: this.getMessage(380), type: 'success'});
            }else{
              this.showModal({title: 'İşlem Başarılı', message: this.getMessage(379), type: 'success'});
            }
            this.$router.go(-1);
        }else{
            this.errorHandling(res);
        }
      }).catch((err) => {
          this.showModal({title: 'Hata!', message: err, type: 'danger'});
          this.$store.state.general.showOverlay = false;
      });
    },
    isEmptyFile(){
      let ret = true;
      this.mbBildirimDosya.forEach(element => {
        if(element.dosyaAdi !== ""){
          ret = false;
        }
      });
      return ret;
    },
    bildirimTuruChange(){
      if(this.form.bildirimTuru){
        let html = this.$store.state.general.parameters.bakanlikBildirimiTuruListe.filter(x => x.id === this.form.bildirimTuru);
        if(html.length > 0)
          this.form.bakanlikAciklama = html[0].description;
      }
    },
    listofMBIdChange(type){
      this.listofMBId = [];
      if(type === 1){
        this.mblist.filter(x => x.faaliyetSektoru === this.form.faaliyetSektoru).forEach(element => {
          this.listofMBId.push(element);
        });
      }else if(type === 2){
        this.mblist.filter(x => x.faaliyetAlani === this.form.faaliyetAlani).forEach(element => {
          this.listofMBId.push(element);
        });
      }else if(type === 3){
        this.mblist.forEach(element => {
          this.listofMBId.push(element);
        });
      }
    },
    clearForm() {
      this.pageTitle= 'Yeni Bakanlık Bildirimi Girişi',
      this.form = Object.assign({}, {
        recordId:0,
        parentId: parseInt(this.$store.state.mb.recordId),
        bildirimTuru :null,
        comment:"",
        bildirimBaslik:"",
        bildirimDurumu:1,
        bakanlikAciklama:"",
        mbAciklama:"",
        listofMBId:"",
        faaliyetSektoru:0,
        faaliyetAlani:0,
        bildirimiYapanUserName:"",
        bildirimTarihi:"",
        mbBildirimDosya:[]
      });
      this.mbBildirimDosya = [];
      this.mbBildirimDosya.push({recordId: 0, parentId: 0, dosyaAdi: "", link: "", file:null});
      // this.mbBildirimDosya.push({recordId: 0, parentId: 0, dosyaAdi: "", link: "", file:null});
      // this.mbBildirimDosya.push({recordId: 0, parentId: 0, dosyaAdi: "", link: "", file:null});
      // this.mbBildirimDosya.push({recordId: 0, parentId: 0, dosyaAdi: "", link: "", file:null});
      // this.mbBildirimDosya.push({recordId: 0, parentId: 0, dosyaAdi: "", link: "", file:null});
      this.listofMBId = [];
      this.$v.$reset();
    },
    getRecord(){
      this.$store.state.general.showOverlay = true;
      this.getMeslekBirligiBakanlikBildirimi(this.$store.state.mb.recordIdBakanlikBildirimi).then(res => {
        if(res.errorCode == 0){
          let bb = res.data;
          this.pageTitle = bb.bildirimBaslik;
          this.form = {
            recordId: bb.recordId,
            parentId: bb.parentId,
            dosyaAdi: bb.dosyaAdi,
            link: bb.link,
            bildirimTuru: bb.bildirimTuru,
            comment: bb.comment,
            bildirimBaslik: bb.bildirimBaslik,
            bildirimDurumu: bb.bildirimDurumu,
            bakanlikAciklama: bb.bakanlikAciklama,
            mbAciklama: bb.mbAciklama,
            listofMBId: bb.listofMBId,
            faaliyetSektoru:0,
            faaliyetAlani:0,
            bildirimiYapanUserName:bb.bildirimiYapanUserName,
            bildirimTarihi:bb.bildirimTarihi,
            mbBildirimDosya:bb.mbBildirimDosya
          };
          if(this.form.listofMBId && this.form.listofMBId.indexof(",") > -1){
            this.form.listofMBId.split(",").forEach(element => {
              var mb = this.mblist.filter(x => x.id === element.id);
              if(mb.length > 0)
                this.listofMBId.push(mb[0]);
            });
          }else{
            var mb = this.mblist.filter(x => x.id === this.form.parentId);
            if(mb.length > 0)
              this.listofMBId.push(mb[0]);
          }
          this.mbBildirimDosya = bb.mbBildirimDosya;
          this.mbBildirimDosya.push({recordId: 0, parentId: 0, dosyaAdi: "", link: "", file:null});
          
          this.dataLoaded = true;
        }else{
          this.$store.state.mb.recordIdBakanlikBildirimi = 0;
          this.errorHandling(res);
        }
        this.$store.state.general.showOverlay = false;
      });
    },
    init(){
      this.getMBListOptions();
      this.$v.form.$reset();
      if(this.$route.params.id){
        this.$store.state.mb.recordIdBakanlikBildirimi = this.$route.params.id;
        this.getRecord();
      }else{
        this.clearForm();
        this.pageTitle = "YENİ BAKANLIK BİLDİRİMİ EKLE";
      }
    },
    onChangeFileUpload(singleIndex) {
      let files = document.getElementById("file" + singleIndex).files;
      if(files.length == 0)
        return;
      if(files.length === 1){
        this.mbBildirimDosya[singleIndex].file = document.getElementById("file" + singleIndex).files[0];
        this.mbBildirimDosya[singleIndex].dosyaAdi = document.getElementById("file" + singleIndex).files[0].name;
      }else{
        if(this.form.recordId && this.form.parentId != 0){
          this.mbBildirimDosya = this.mbBildirimDosya.filter(x => x.recordId != 0);
        }else{
          this.mbBildirimDosya = [];
        }
        files.forEach(element => {
          this.mbBildirimDosya.push({
            recordId: 0,
            parentId: 0,
            dosyaAdi: element.name,
            link: "",
            file:element
          });
        });
      }
    },
    onChangeFileUploadClick(index){
      document.getElementById("file" + index).click();
    },
    onFileRemove(index){
      this.removeListObject(index, this.mbBildirimDosya);
      let blankRecord = this.mbBildirimDosya.filter(x => x.recordId === 0);
      if(blankRecord.length === 0){
        this.mbBildirimDosya.push({recordId: 0, parentId: 0, dosyaAdi: "", link: "", file:null});
      }
    },
    getMBListOptions(){
      if(this.$store.state.auth.user.mbId !== 0)
        return;

      this.$store.state.general.showOverlay = true;
      this.getMBList().then(res => {
        if(res.errorCode == 0){
            this.mblist = res.data;
        }else{
            this.errorHandling(res);
        }
        this.$store.state.general.showOverlay = false;
      });
    },
    print() {
    const printWindow = window.open('', '_blank', 'height=500,width=700');

    if (!printWindow) {
        alert('Yazdırma penceresi açılamadı. Açılır pencere engelleyicisini kontrol edin.');
        return false;
    }

    const bildirimTarihi = this.form.bildirimTarihi
        ? moment(String(this.form.bildirimTarihi)).format('DD.MM.YYYY')
        : '';

    const html = `
        <!DOCTYPE html>
        <html lang="tr">
        <head>
            <meta charset="UTF-8">
            <title>${document.title}</title>

            <style>
                body {
                    margin: 20px;
                    font-family: Arial, sans-serif;
                    background-color: #fff;
                    color: #000;
                    font-size: 14px;
                }

                table {
                    width: 100%;
                    border-collapse: collapse;
                }

                .label {
                    width: 200px;
                    padding: 5px 30px 5px 0;
                    font-weight: 500;
                    vertical-align: top;
                }

                .value {
                    padding: 5px 0;
                    vertical-align: top;
                }

                .section-title {
                    padding: 15px 0 5px;
                    font-weight: 500;
                }

                .description {
                    padding: 8px;
                    border: 1px solid rgba(0, 0, 0, 0.3);
                    white-space: pre-wrap;
                    overflow-wrap: anywhere;
                }
            </style>
        </head>

        <body>
            <table>
                <tr>
                    <td class="label">Bildirim Tarihi</td>
                    <td class="value">${bildirimTarihi}</td>
                </tr>

                <tr>
                    <td class="label">Bildirim Yapan Kullanıcı Adı</td>
                    <td class="value">${this.form.bildirimiYapanUserName || ''}</td>
                </tr>

                <tr>
                    <td class="label">Bildirim Durumu</td>
                    <td class="value">
                        ${this.getOptionWithParams(
                            this.form.bildirimDurumu,
                            'bildirimDurumu'
                        ) || ''}
                    </td>
                </tr>

                <tr>
                    <td class="label">Bildirim Türü</td>
                    <td class="value">
                        ${this.getOptionWithParams(
                            this.form.bildirimTuru,
                            'bakanlikBildirimiTuruListe'
                        ) || ''}
                    </td>
                </tr>

                <tr>
                    <td class="label">Bildirim Başlığı</td>
                    <td class="value">${this.form.bildirimBaslik || ''}</td>
                </tr>

                <tr>
                    <td class="label">Dosya Adı</td>
                    <td class="value">${this.form.dosyaAdi || ''}</td>
                </tr>

                <tr>
                    <td class="section-title" colspan="2">
                        Bakanlık Açıklama
                    </td>
                </tr>

                <tr>
                    <td class="description" colspan="2">
                        ${this.form.bakanlikAciklama || ''}
                    </td>
                </tr>

                <tr>
                    <td class="section-title" colspan="2">
                        Meslek Birliği Açıklama
                    </td>
                </tr>


                <tr>
                    <td class="description" colspan="2">
                        ${this.form.mbAciklama || ''}
                    </td>
                </tr>
            </table>
        </body>
        </html>
    `;

    printWindow.document.open();
    printWindow.document.write(html);
    printWindow.document.close();

    printWindow.onload = () => {
        printWindow.focus();

        setTimeout(() => {
            printWindow.print();
        }, 250);
    };

    printWindow.onafterprint = () => {
        printWindow.close();
    };

    return true;
},
    goBack() {
      if (this.isChanged) {
        this.$bvModal.show("modal-cancel-confirm");
      } else {
        this.$router.go(-1);
      }
    }
  },
  created() {
    this.init();
  },
  watch: {},
};
</script>